import React from "react";
import { withStyles } from "@material-ui/styles";
import { I18n } from "@aws-amplify/core";
import { get, isEmpty, map } from "lodash";
import Box from "@material-ui/core/Box";
import Grid from "@material-ui/core/Grid";
import Radio from "@material-ui/core/Radio";
import Dialog from "@material-ui/core/Dialog";

import CloseIcon from "../../Common/CloseIcon";
import AddVerification from "../../Profiles/AddVerification";
import { getAttributeValue } from "../../../utils/profile";
import { getVerificationStatus } from "../../../utils/eventGroups";
import {
  VERIFICATION_OK,
  VERIFICATION_WARNING,
  VERIFICATION_THREAT,
} from "../../../constants/eventGroups";
import colors from "../../../assets/style/colors";
import images from "../../../assets/img/images";

const styles = {
  verificationContainer: {
    padding: "10px 8px",
    marginTop: "-5px",
    height: "100%",
  },
  lukeActionColor: {
    marginRight: "5px",
    width: "14px",
    minWidth: "14px",
    height: "14px",
    borderRadius: "2px",
  },
  buttonIcon: {
    padding: "0px !important",
    minWidth: "0px",
    "& img": {
      height: "36px",
    },
  },
  plusIcon: {
    cursor: "pointer",
    display: "flex",
    alignItems: "center",
    marginTop: "4px",
  },
  link: {
    color: colors.primary,
    cursor: "pointer",
    "& :hover": {
      textDecoration: "underline",
    },
  },
  closeIcon: {
    display: "flex",
    justifyContent: "flex-end",
  },
};

const WalkInOutVerification = (props) => {
  const {
    classes,
    profile,
    language,
    onSubmitVerification,
    noVerificationSubmit,
    verification,
  } = props;

  const [open, setOpen] = React.useState(false);
  const verificationStatus = getVerificationStatus(
    get(verification, ["surveyEvent"])
  );

  let attr151 = getAttributeValue(get(verification, ["surveyEvent"]), 151);
  if (attr151) attr151 = JSON.parse(attr151);

  return (
    <Box className={classes.verificationContainer}>
      <Box style={{ display: "flex" }}>
        <img
          src={images.checklistIconBlack}
          style={{ marginRight: "10px" }}
          alt="verification"
        />
        <AddVerification
          profile={profile}
          language={language}
          refreshHistory={() => { }}
          isMe={false}
          onSubmit={onSubmitVerification}
          noVerificationSubmit={noVerificationSubmit}
          companies={props.companies}
          sites={props.sites}
          zones={props.zones}
          noConfirmation={props.noConfirmation}
        />
      </Box>
      {!isEmpty(verification) && (
        <Grid container wrap="nowrap" style={{ marginTop: "6px" }}>
          <Grid item>
            <img
              src={
                verificationStatus === VERIFICATION_THREAT
                  ? images.verificationIconWarning
                  : verificationStatus === VERIFICATION_WARNING
                    ? images.warningTriangleOrange
                    : verificationStatus === VERIFICATION_OK
                      ? images.greenCheckmarkWhite
                      : ""
              }
              alt="status"
              style={{ display: "inline-block", marginRight: "5px" }}
              height="17px"
            />
          </Grid>
          <Grid item className={classes.link} onClick={() => setOpen(true)}>
            {get(verification, ["verification", `description_${language}`])}
          </Grid>
        </Grid>
      )}
      <Dialog open={open}>
        <Grid
          container
          wrap="nowrap"
          direction="column"
          alignItems="stretch"
          style={{ height: "100%", padding: "12px" }}
        >
          <Grid item>
            <Grid container alignItems="center">
              <Grid item xs={2} />
              <Grid
                item
                xs
                className="dialogTitle flexCenter"
                style={{ justifyContent: "center" }}
              >
                {get(verification, ["verification", `description_${language}`])}
              </Grid>
              <Grid item xs={2} className={classes.closeIcon}>
                <CloseIcon closeFunction={() => setOpen(false)} />
              </Grid>
            </Grid>
          </Grid>
          <Grid
            item
            style={{
              padding: "12px",
              border: `1px solid ${colors.veryLighPink}`,
              borderRadius: "4px",
              margin: "12px",
            }}
          >
            {map(get(attr151, ["questions", "answers"]), (q, i) => (
              <Grid item key={i}>
                <Box className="text-87 bold-500">
                  {`${get(q, ["question", "number"]) + 1}. ${get(q, [
                    "question",
                    "text",
                  ])}`}
                </Box>
                <Grid container>
                  <Grid item>
                    <Radio
                      color="primary"
                      checked={get(q, ["answer"]) === "no"}
                      disabled
                    />
                    {I18n.get("site_no")}
                  </Grid>
                  <Grid item>
                    <Radio
                      color="primary"
                      checked={get(q, ["answer"]) === "yes"}
                      disabled
                    />
                    {I18n.get("site_yes")}
                  </Grid>
                </Grid>
              </Grid>
            ))}
          </Grid>
        </Grid>
      </Dialog>
    </Box>
  );
};

export default withStyles(styles)(WalkInOutVerification);
